import {
  CreateFolderDto,
  FolderDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { DOMAIN_FOLDERS } from "../domain";
import { ACTION_GET_FOLDER } from "../GetFolder/useGetFolder";

import { foldersApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_CREATE_FOLDER = "CREATE_FOLDER";

const allowedRoles = [UserRole.Owner];

const createFolder = async (params: CreateFolderDto): Promise<FolderDto> => {
  const response = await foldersApi.foldersControllerCreateFolder(
    params as CreateFolderDto,
  );

  return response.data;
};

export const useCreateFolder = (
  user: UserProfileDto | null,
): {
  createFolder: (params: CreateFolderDto) => Promise<FolderDto>;
  createFolderEnabled: boolean;
  isSuccessCreateFolder: boolean;
  isPendingCreateFolder: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FOLDERS, ACTION_CREATE_FOLDER],
    mutationFn: enabled ? createFolder : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_FOLDERS, ACTION_GET_FOLDER],
      });
    },
  });

  return {
    createFolder: mutateAsync,
    createFolderEnabled: enabled,
    isSuccessCreateFolder: isSuccess,
    isPendingCreateFolder: isPending,
  };
};
